import React, { useState } from 'react';
import './AnnouncementBar.css';

interface AnnouncementBarProps {
  message: string;
  link?: { href: string; label: string };
}

const AnnouncementBar: React.FC<AnnouncementBarProps> = ({ message, link }) => {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <div className="announcement-bar" role="banner">
      <p className="announcement-bar__text">
        {message}
        {link && (
          <a href={link.href} className="announcement-bar__link">
            {link.label}
          </a>
        )}
      </p>
      <button
        className="announcement-bar__close"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss announcement"
      >
        ×
      </button>
    </div>
  );
};

export default AnnouncementBar;
